import { APP_COLOR,APP_HOVER_COLOR, FONT_FAMILY } from "../../theme";

export const styles = {
  firstHeading: {
    fontWeight: "bold",
    marginTop: "65px",
    fontSize: "62px",
    fontFamily: FONT_FAMILY,
  } as const,
  secondHeading: {
    fontSize: "30px",
    fontFamily: FONT_FAMILY,
  } as const,
  buttonContainer: {
    display: "flex",
    width: "80%",
    flexDirection: "column",
    marginTop: "-12px",
  } as const,
  container: {
    color: "white",
    minHeight: 750,
    height: "100vh",
    textAlign: "left",
    border: "1px solid black",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  } as const,
  headerContainer: {
    width: "80%",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
  } as const,
  buttonStyle: {
    margin: "auto",
    marginTop: "20px",
    width: "220px",
    fontSize: "22px",
    color: "white",
    textTransform: "none",
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
};
